/**
 * 
// 描边连接类型
export type StrokeLinejoin = 'miter' | 'round' | 'bevel';

// 描边端点类型
export type StrokeLinecap = 'butt' | 'round' | 'square';

// 主题
export type Theme = 'outline' | 'filled' | 'two-tone' | 'multi-color';
 * 
 */

const base = {
    size: 16,
    strokeWidth: 4,
    strokeLinecap: 'butt',
    strokeLinejoin: 'miter',
}

function initColors(
    theme, 
    customColor = ['#000000', '#000000', '#000000', '#000000'], 
    isCurrentColor = true) {
    const colors = Array(3).fill(customColor[0]);
    // 以下为留白逻辑
    // 线性
    if (theme === 'outline') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[0];
        colors[1] = '#ffffff';
        colors[2] = isCurrentColor ? 'currentColor' : customColor[0];
    }
    // 面性
    if (theme === 'filled') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[1] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[2] = '#ffffff';
    }
    // 双色
    if (theme === 'two-tone') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[0];
    }
    // 多色
    if (theme === 'multi-color') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[2];
    }
    return colors;
}

function initSize(size, isFontSize = false) {
    return isFontSize ? '1em' : `${size}px`;
}

export default {
    name: 'commonIconEdit1',
    cName: '编辑1',
    render(config) {
        const props = {
            ...base,
            ...config,
            size: initSize(config.size, config.isFontSize),
            colors: initColors(config.theme, config.colors, config.isCurrentColor)
        }
        return this.svgFn(props);
    },
    svgFn: (props) => (
        `
        <svg width="${props.size}" height="${props.size}" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" stroke-width="${props.strokeWidth}" fill="none" fill-rule="evenodd">
                <g transform="translate(6.000000, 4.000000)" stroke="${props.colors[0]}" stroke-linecap="${props.strokeLinecap}" stroke-width="${props.strokeWidth}">
                    <path d="M34,22 L34,37 C34,37.5522847 33.5522847,38 33,38 L1,38 C0.44771525,38 6.76353751e-17,37.5522847 0,37 L0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 L16,4 L16,4"></path>
                    <path d="M32.7091222,0.709122153 L37.2928932,5.29289322 C37.6824844,5.68382671 37.6827845,6.31647437 37.2935644,6.7077773 L18.9517645,25.0844122 L18.9517645,25.0844122 L12,26.0723533 L12.9879411,19.1205888 L31.292899,0.711137517 C31.6823102,0.319503334 32.3154726,0.31770128 32.7071068,0.707112517 C32.7077795,0.707781439 32.7084513,0.708451319 32.7091222,0.709122153 Z" stroke-linejoin="${props.strokeLinejoin}"></path>
                </g>
            </g>
        </svg>
        `
    )
};
